import React, { useEffect, useState } from 'react';

import { SITE_USER_COOKIE } from '@/constants/site';
import { SUBSCRIPTION_TYPE } from '@/constants/subscription-type';
import { getFromCookies } from '@/helpers/cookies';

export const HbAdType = {
    HALF_PAGE_1: 175341,
    MOBILE_LEADERBOARD: 35326,
    FOOTER_MOBILE_LEADERBOARD: 255089,
    FOOTER_MOBILE_LEADERBOARD_2: 255091,
    AF_300x250_2: 37288,
    AF_300x100_MOBILE: 176437,
    STICKY_BOTTOM: 176925,
    BILLBOARD: 177071,
    AF_INTERSCROLLER: 177386,
    MAGIC_LEFT: 177436,
    MOBILE_DESKTOP_LEADERBOARD: 177437,
    MOBILE_DESKTOP_LEADERBOARD_2: 177438,
    AF_300x600_1: 182841,
    AF_300x600_2: 182842,
    INTERSITIAL: 33042,
    FIXED_BOTTOM: 211558,
    WIDE_SCRAPPER_LEFT_160x600: 213687,
    WIDE_SCRAPPER_LEFT_2_160x600: 213688,
    WIDE_SCRAPPER_RIGHT_160x600: 213689,
    WIDE_SCRAPPER_RIGHT_2_160x600: 213690,
    Mobile_320x100: 213453,
    Mobile_320x100_2: 213691,
    OUTSTREAM_VIDEO: 33041,
    IN_PAGE: 90679,
};

export const hbAdComponents = {
    [HbAdType.FIXED_BOTTOM]: (
        <div id="HB_Footer_Close_hbagency_space_211558">
            <div id="HB_CLOSE_hbagency_space_211558"></div>
            <div id="HB_OUTER_hbagency_space_211558">
                <div id="hbagency_space_211558"></div>
            </div>
        </div>
    ),
    [HbAdType.MOBILE_DESKTOP_LEADERBOARD]: (
        <div className="hb-ad-static hb-ad-leaderbord d-flex-center">
            <div className="hb-ad-inner">
                <div className="hbagency_cls_static" id="hbagency_space_177437"></div>
            </div>
        </div>
    ),
    [HbAdType.MOBILE_DESKTOP_LEADERBOARD_2]: (
        <div className="hb-ad-static hb-ad-leaderbord d-flex-center">
            <div className="hb-ad-inner">
                <div className="hbagency_cls_static" id="hbagency_space_177438"></div>
            </div>
        </div>
    ),
    [HbAdType.HALF_PAGE_1]: (
        <div className="hb-ad-static hb-ad-half hb-container d-flex-center">
            <div className="hb-ad-inner">
                <div className="hbagency_cls_static" id="hbagency_space_175341"></div>
            </div>
        </div>
    ),
    [HbAdType.MOBILE_LEADERBOARD]: (
        <div className="hb-ad-static hb-ad-a320x100 hb-ad-leaderboard d-flex-center">
            <div className="hb-ad-inner">
                <div className="hbagency_cls_static" id="hbagency_space_35326"></div>
            </div>
        </div>
    ),
    [HbAdType.FOOTER_MOBILE_LEADERBOARD]: (
        <div class="hb-ad-static hb-ad-leaderbord">
            <div class="hb-ad-inner">
                <div class="hbagency_cls_static" id="hbagency_space_255089"></div>
            </div>
        </div>
    ),
    [HbAdType.FOOTER_MOBILE_LEADERBOARD_2]: (
        <div class="hb-ad-static hb-ad-leaderbord">
            <div class="hb-ad-inner">
                <div class="hbagency_cls_static" id="hbagency_space_255091"></div>
            </div>
        </div>
    ),
    [HbAdType.AF_300x250_2]: (
        <div className="hb-ad-inarticle hb-container d-flex-center">
            <div className="hb-ad-inner">
                <div className="hbagency_cls" id="hbagency_space_37288"></div>
            </div>
        </div>
    ),
    [HbAdType.AF_300x100_MOBILE]: (
        <div className="hb-ad-static hb-ad-a320x100 d-flex-center">
            <div className="hb-ad-inner">
                <div className="hbagency_cls_static" id="hbagency_space_176437"></div>
            </div>
        </div>
    ),
    [HbAdType.STICKY_BOTTOM]: (
        <div id="HB_Footer_Close_hbagency_space_176925">
            <div id="HB_CLOSE_hbagency_space_176925"></div>
            <div id="HB_OUTER_hbagency_space_176925">
                <div id="hbagency_space_176925"></div>
            </div>
        </div>
    ),
    [HbAdType.MAGIC_LEFT]: (
        <div id="HB_Footer_Close_hbagency_space_177436">
            <div id="HB_CLOSE_hbagency_space_177436"></div>
            <div id="HB_OUTER_hbagency_space_177436">
                <div id="hbagency_space_177436"></div>
            </div>
        </div>
    ),
    [HbAdType.BILLBOARD]: (
        <div className="hb-ad-static hb-ad-billboard d-flex-center">
            <div className="hb-ad-inner">
                <div className="hbagency_cls_static" id="hbagency_space_177071"></div>
            </div>
        </div>
    ),
    [HbAdType.AF_INTERSCROLLER]: (
        <div className="hb-ad-inarticle d-flex-center">
            <div className="hb-ad-inner">
                <div className="hbagency_cls" id="hbagency_space_177386"></div>
            </div>
        </div>
    ),
    [HbAdType.AF_300x600_1]: (
        <div className="hb-ad-static hb-ad-half">
            <div className="hb-ad-inner">
                <div className="hbagency_cls_static" id="hbagency_space_182841"></div>
            </div>
        </div>
    ),
    [HbAdType.AF_300x600_2]: (
        <div className="hb-ad-static hb-ad-half">
            <div className="hb-ad-inner">
                <div className="hbagency_cls_static" id="hbagency_space_182842"></div>
            </div>
        </div>
    ),
    [HbAdType.WIDE_SCRAPPER_LEFT_160x600]: (
        <div class="hb-ad-static hb-ad-sky">
            <div class="hb-ad-inner">
                <div class="hbagency_cls_static" id="hbagency_space_213687"></div>
            </div>
        </div>
    ),
    [HbAdType.WIDE_SCRAPPER_LEFT_2_160x600]: (
        <div class="hb-ad-static hb-ad-sky">
            <div class="hb-ad-inner">
                <div class="hbagency_cls_static" id="hbagency_space_213688"></div>
            </div>
        </div>
    ),
    [HbAdType.WIDE_SCRAPPER_RIGHT_160x600]: (
        <div class="hb-ad-static hb-ad-sky">
            <div class="hb-ad-inner">
                <div class="hbagency_cls_static" id="hbagency_space_213689"></div>
            </div>
        </div>
    ),
    [HbAdType.WIDE_SCRAPPER_RIGHT_2_160x600]: (
        <div class="hb-ad-static hb-ad-sky">
            <div class="hb-ad-inner">
                <div class="hbagency_cls_static" id="hbagency_space_213690"></div>
            </div>
        </div>
    ),
    [HbAdType.Mobile_320x100]: (
        <div class="hb-ad-static hb-ad-a320x100">
            <div class="hb-ad-inner">
                <div class="hbagency_cls_static" id="hbagency_space_213453"></div>
            </div>
        </div>
    ),
    [HbAdType.Mobile_320x100_2]: (
        <div class="hb-ad-static hb-ad-a320x100">
            <div class="hb-ad-inner">
                <div class="hbagency_cls_static" id="hbagency_space_213691"></div>
            </div>
        </div>
    ),
    [HbAdType.INTERSITIAL]: <div id="hbagency_space_33042"></div>,
    [HbAdType.OUTSTREAM_VIDEO]: <div id="hbagency_space_33041"></div>,
    [HbAdType.IN_PAGE]: <div id="hbagency_space_90679"></div>,
};

const HbAdComponent = ({ type }) => {
    const [isClient, setIsClient] = useState(false);

    useEffect(() => {
        setIsClient(true);
    }, []);

    useEffect(() => {
        if (!isClient) {
            return;
        }
    }, [type, isClient]);

    if (!isClient) {
        return null;
    }

    const dataFromCookies = getFromCookies(SITE_USER_COOKIE);
    const data = JSON.parse(dataFromCookies);

    if (data && data.subscriptionType !== SUBSCRIPTION_TYPE.FREE) {
        return null;
    }

    return hbAdComponents[type] || null;
};

export default HbAdComponent;
